import React from 'react'
import { Field } from 'formik'

const FormCheckBox = ({ labelGroup, name, data }) => (
  <div className="flex flex-col w-full h-full">
    {labelGroup && (
      <label htmlFor={name} className="font-medium block mb-2 text-md text-gray-700">
        {labelGroup}
      </label>
    )}
    <div role="group" aria-labelledby="checkbox-group">
      {data.map((item, index) => (
        <div key={index} className="flex flex-col mb-2">
          <div className="flex flex-row items-center justify-start space-x-2">
            <Field
              className="hover:cursor-pointer accent-primary-500 w-4 h-4"
              type="checkbox"
              name={name}
              value={item.value}
            />
            <span className="font-medium text-gray-700">{item.label}</span>
          </div>
        </div>
      ))}
    </div>
  </div>
)

export default FormCheckBox
